export const COMPANY_MICROTREND_DELETED = 'COMPANY_MICROTREND_DELETED'
export const SEARCH_AGENT_ADDED = 'SEARCH_AGENT_ADDED'
export const SHOW_DATA_PROTECTION = 'SHOW_DATA_PROTECTION'
export const WORKSPACE_NODE_REMOVED = 'WORKSPACE_NODE_REMOVED'
export const COMFORT_VOTER_RELOAD = 'COMFORT_VOTER_RELOAD'
